import type { MagentoAccount } from "../../slices/accountsSlice";

const STORAGE_KEY = "magento_accounts";

export function loadAccountsFromStorage() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { accounts: [], activeAccountId: null as string | null };
    const parsed = JSON.parse(raw) as {
      accounts: MagentoAccount[];
      activeAccountId: string | null;
    };
    return {
      accounts: parsed.accounts || [],
      activeAccountId: parsed.activeAccountId ?? null,
    };
  } catch (error) {
    console.warn("Failed to load accounts from storage:", error);
    return { accounts: [], activeAccountId: null as string | null };
  }
}

export function saveAccountsToStorage(accounts: MagentoAccount[], activeAccountId: string | null) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ accounts, activeAccountId }));
  } catch (error) {
    console.warn("Failed to save accounts to storage:", error);
  }
}
